import React from "react";

const SVG = ({
  style = {},
  width = "100%",
  height = "100%",
  className = "",
  viewBox = "0 0 1024 1024"
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svgIcon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="PinkHeadphone">
      <g
        id="Right"
        transform="translate(774.500000, 400.000000) scale(-1, 1) translate(-774.500000, -400.000000) translate(723.000000, 286.000000)"
      >
        <path
          id="Inside"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFCCE7"
          d="M85.5,0c15.8,0,20.9,13,15.4,39
			c-1.9,24.7-3.1,49.8-3.5,75.3s0.8,51.8,3.5,79.1c5.5,23.1,0.3,34.7-15.4,34.7c-5.4,0-13.8-4-17-10.6c-10.8-22.2-6.6-74-6.6-103.4
			c0-27.7-0.7-80.3,8.4-104.3C73.6,0.7,79,0,85.5,0z"
        />
        <path
          id="Outside"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#F54291"
          d="M0.3,116.7c-0.1-0.6-0.1-1.2-0.1-1.8
			C-1.1,76.4,5,61.3,14.8,25.6c12.5,0.9,3.3-6,12.2-6.3c3.6-0.1,10.8,1.1,21.1-2.9c3-1.2,7.5-5,13.4-9c4.4-3,7.9-3.1,10.5-0.4
			c-5.5,43.6-7.8,78.8-6.9,105.6c0.1,2.5-0.1,4.9-0.5,7.1c0,0.4,0,0.8,0,1.3c0,26.7,3.5,61.7,10.4,104.9c-2.5,2.8-5.9,2.8-10.4,0
			c-6-3.8-10.6-7.4-13.6-8.5c-10.4-3.7-17.5-2.2-21.1-2.2c-8.9,0,0-7.2-12.4-5.9C6.6,174.2,0,159.3,0,120.9
			C0,119.5,0.1,118,0.3,116.7z"
        />
      </g>
      <g id="Left" transform="translate(198.000000, 286.000000)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFCCE7"
          d="M85.5,0c15.8,0,20.9,13,15.4,39c-1.9,24.7-3.1,49.8-3.5,75.3
			s0.8,51.8,3.5,79.1c5.5,23.1,0.3,34.7-15.4,34.7c-5.4,0-13.8-4-17-10.6c-10.8-22.2-6.6-74-6.6-103.4c0-27.7-0.7-80.3,8.4-104.3
			C73.6,0.7,79,0,85.5,0z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#F54291"
          d="M0.3,116.7c-0.1-0.6-0.1-1.2-0.1-1.8C-1.1,76.4,5,61.3,14.8,25.6
			c12.5,0.9,3.3-6,12.2-6.3c3.6-0.1,10.8,1.1,21.1-2.9c3-1.2,7.5-5,13.4-9c4.4-3,7.9-3.1,10.5-0.4c-5.5,43.6-7.8,78.8-6.9,105.6
			c0.1,2.5-0.1,4.9-0.5,7.1c0,0.4,0,0.8,0,1.3c0,26.7,3.5,61.7,10.4,104.9c-2.5,2.8-5.9,2.8-10.4,0c-6-3.8-10.6-7.4-13.6-8.5
			c-10.4-3.7-17.5-2.2-21.1-2.2c-8.9,0,0-7.2-12.4-5.9C6.6,174.2,0,159.3,0,120.9C0,119.5,0.1,118,0.3,116.7z"
        />
      </g>
      <path
        id="Top"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F76EAA"
        stroke="#F76EAA"
        strokeWidth="4"
        d="M342.4,212.2
		c-42.2,26.7-67.8,59.8-76.7,99.2c-3.2,14.2-5.7,37.6-7.3,69.9l0,0.6l-0.4,0.5c-6.3,8.3-13,12.5-20.1,12.5c-7.1,0-13-3.5-17.6-10.3
		l-0.4-0.5l0-0.6c0.9-36.1,3.3-61,7.1-74.9c14.1-51.5,43.3-94.1,87.5-128l-2.5-2.8l1.7-1.3c56.6-43.2,122-64.8,196.3-64.8
		c74.3,0,141,22.3,200.1,66.9l1.7,1.3l-1.2,1.4c43.6,33.7,72.4,76.2,86.4,127.2c3.8,13.9,6.2,38.8,7.1,74.9l0,0.6l-0.4,0.5
		c-4.6,6.8-10.5,10.3-17.6,10.3c-7.1,0-13.8-4.3-20.1-12.5l-0.4-0.5l0-0.6c-1.6-32.3-4-55.6-7.3-69.9c-8.9-38.9-33.8-71.6-75-98.1
		l-1.2,1.4l-1.5-0.9c-55.2-33.1-111.5-49.6-168.9-49.6c-57.4,0-112.7,16.5-166.1,49.6l-1.4,0.9l-1.1-1.3L342.4,212.2z"
      />
    </g>
  </svg>
);

export default SVG;
